<template>
  <span class="item-title">
    <span>{{ title }}</span>
  </span>
</template>
<script>
export default {
  name: 'MenuItem',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style  lang="scss" scoped>
.item-title{
  flex: 1;
  .svg-icon {
    margin-right: 10px;
    color: currentColor;
    width: 1em;
    height: 1em;
  }
  .title{
    height: 1.3em;
    line-height: 1.3em;;
  }
}

</style>
